import { memo } from 'react';
import { SOFQuestionProps } from './SOFQuestion.types';
import { Box, Text } from '@betty/moonlight';
import SOFQuestionCheckboxes from '../SOFCheckboxes/SOFQuestionCheckboxes';
import SOFQuestionInput from '../SOFQuestionInput/SOFQuestionInput';
import { useTranslation } from '@betty/i18n';

function SOFQuestions({
  id,
  type,
  subtitle,
  answers,
  options,
  error,
  number,
  controlId = '',
  onCheckboxChange,
  onInputChange,
  inputRef,
  onSubmitEditing,
}: SOFQuestionProps) {
  const { t } = useTranslation('sof');

  return (
    <Box gap="space-400">
      <Text variant="body-s-semi" color="darkSurfacePrimary">
        {number}. {t(`question${number}.title`)}
      </Text>
      {subtitle && (
        <Text variant="body-s" color="darkSurfacePrimary">
          {t(`question${number}.subtitle`)}
        </Text>
      )}

      {type === 'checkbox' ? (
        <SOFQuestionCheckboxes
          questionId={id}
          options={options}
          answers={answers}
          error={error}
          onChange={onCheckboxChange}
          onAdditionalTextChange={onInputChange}
          inputRef={inputRef}
          onSubmitEditing={onSubmitEditing}
        />
      ) : null}

      {type === 'text' ? (
        <SOFQuestionInput
          questionId={id}
          controlId={controlId || ''}
          labelNS="account"
          labelKey="answer"
          error={error?.major}
          value={answers[controlId].answer || ''}
          onChange={onInputChange}
          inputRef={inputRef}
          onSubmitEditing={onSubmitEditing}
        />
      ) : null}
    </Box>
  );
}

export default memo(SOFQuestions);
